// extracted by mini-css-extract-plugin
module.exports = {"wrap":"tn-z","title":"un-z","cta":"vn-z","disabled":"wn-z"};